import type { ReactNode } from 'react';

export const symbol_money_bag: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M332-120q-88 0-150-62t-62-150q0-38 13-72.5t36-63.5l152-182-73-147q-8-15 1-29t26-14h411q17 0 26 14t1 29l-73 147 151 182q24 29 36.5 63.5T841-332q0 88-62 150t-150 62H332Zm148-218q-25 0-42-17.5T421-398q0-25 17-42.5t42-17.5q26 0 43.5 17.5T541-398q0 25-17.5 42.5T480-338ZM375-675h210l53-105H323l52 105Zm-43 495h296q63 0 107.5-44.5T780-332q0-27-9-52t-26-45L590-615H370L216-429q-17 20-26.5 45t-9.5 52q0 63 44.5 107.5T332-180Z"
		/>
	</svg>
);
